import React from 'react';
import { WhatsAppIcon, PhoneIcon } from '../Icons';
import { WA_NUMBER } from '../../data/constants';
import { waLink, promesaDeRespuesta } from '../../utils/whatsapp';
import './WhatsAppButton.css';

const MSG_FLOTANTE = 'Hola, estoy en su página web y necesito asesoría legal. ¿Me pueden ayudar?';

/* Contacto siempre a la vista.
   En escritorio: pastilla fija con texto — un ícono suelto se lee como adorno,
   la pastilla con texto se lee como una invitación a escribir.
   En móvil (de donde llega casi todo el tráfico de búsqueda y de anuncios):
   barra inferior fija con las dos acciones que realmente cierran, escribir y
   llamar, siempre al alcance del pulgar sin tener que volver arriba. */
const WhatsAppButton: React.FC = () => {
  const href = waLink(MSG_FLOTANTE);

  return (
    <>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-btn"
        aria-label="Escribir por WhatsApp"
      >
        <WhatsAppIcon size={24} />
        <span className="whatsapp-btn-label">
          Escríbenos
          <small>{promesaDeRespuesta()}</small>
        </span>
      </a>

      <div className="contacto-bar" role="group" aria-label="Contacto rápido">
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="contacto-bar-wa"
        >
          <WhatsAppIcon size={19} /> WhatsApp
        </a>
        <a href={`tel:+${WA_NUMBER}`} className="contacto-bar-tel">
          <PhoneIcon size={17} /> Llamar
        </a>
      </div>
    </>
  );
};

export default WhatsAppButton;
